import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import type { Resource } from '../store/resourceStore';

interface ResourceCardProps {
  resource: Resource;
  onRoleClick: (role: 'W2' | '1099') => void;
  onSkillClick: (skill: string) => void;
}

export function ResourceCard({ resource, onRoleClick, onSkillClick }: ResourceCardProps) {
  return (
    <div className="bg-gray-800 rounded-lg p-6">
      <div className="flex justify-between items-start mb-4">
        <div>
          <Link 
            to={`/resources/${resource.id}`}
            className="text-lg font-medium text-white hover:text-red-500 transition-colors"
          >
            {resource.name}
          </Link>
          <p className="text-gray-400">{resource.title}</p>
        </div>
        <button
          onClick={() => onRoleClick(resource.role)}
          className={clsx(
            'px-2 py-1 text-xs font-medium rounded-full cursor-pointer transition-colors',
            resource.role === 'W2' ? 'bg-blue-100 text-blue-800 hover:bg-blue-200' : 'bg-purple-100 text-purple-800 hover:bg-purple-200'
          )}>
          {resource.role}
        </button>
      </div>

      <div className="flex items-center mb-4">
        <ClockIcon className="h-5 w-5 text-red-500 mr-2" />
        <span className="text-gray-300">{resource.availableHours} hours available</span>
      </div>

      <div className="space-y-2">
        <p className="text-sm text-gray-400">Skills:</p>
        <div className="flex flex-wrap gap-2">
          {resource.skills.map((skill, index) => (
            <button
              onClick={() => onSkillClick(skill)}
              key={index}
              className="px-2 py-1 text-xs bg-gray-700 text-gray-300 rounded-full hover:bg-gray-600 transition-colors cursor-pointer"
            >
              {skill}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}